export function renderMarkdown(md: string): string {
  if (!md || !md.trim()) {
    return '<p class="muted">No description yet.</p>';
  }
  try {
    const raw = marked.parse(md, { breaks: true, gfm: true });
    return DOMPurify.sanitize(raw, { USE_PROFILES: { html: true } });
  } catch {
    return '<p class="muted">Could not render description.</p>';
  }
}
